import React from "react";
import { RiArrowLeftLine, RiArrowRightLine } from "react-icons/ri";

export const SlideImage = ({ src, alt, className }) => {
  return (
    <img
      src={src}
      alt={alt}
      className={className}
      onError={(e) => {
        e.target.style.display = "none";
      }}
    />
  );
};

export const TitleDescription = ({
  year,
  yearRef,
  yearClassName,
  title,
  description,
  titleRef,
  descRef,
  titleClassName,
  descClassName,
}) => {
  return (
    <>
      {year != null && (
        <div ref={yearRef} className={yearClassName}>
          {year}
        </div>
      )}
      <h3 ref={titleRef} className={titleClassName}>
        {title}
      </h3>
      <p ref={descRef} className={descClassName}>
        {description}
      </p>
    </>
  );
};

export const DesktopControls = ({ busy, onPrev, onNext }) => {
  return (
    <div className="historyDesktopButtons">
      <button
        onClick={onPrev}
        disabled={busy}
        className={`historyDesktopButton historyDesktopButton--prev ${busy ? "isBusy" : ""}`}
        aria-label="Previous"
      >
        <RiArrowLeftLine size={24} />
      </button>
      <button
        onClick={onNext}
        disabled={busy}
        className={`historyDesktopButton historyDesktopButton--next ${busy ? "isBusy" : ""}`}
        aria-label="Next"
      >
        <RiArrowRightLine size={24} />
      </button>
    </div>
  );
};

